import ModalProductHits from "./ModalProductHits"

export default ModalProductHits